/**
 * A utility function that removes the leading slash, if present, from a URL or
 * a portion of it.
 *
 * @param urlPart URL or portion of it.
 */
function trimLeadingSlash(urlPart) {
  return urlPart.startsWith("/") ? urlPart.replace(/^\//, "") : urlPart;
}

/**
 * A utility function that removes the trailing slash, if present, from a URL or
 * a portion of it.
 *
 * @param url URL or portion of it.
 */
function trimTrailingSlash(url) {
  return url.endsWith("/") ? url.replace(/\/$/, "") : url;
}

export { trimLeadingSlash, trimTrailingSlash };
//# sourceMappingURL=url-utils.js.map
